import PropTypes from "prop-types";
import { FormattedDate, FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import "./TechnicalErrorDuplicateBooking.scss";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";

const TechnicalErrorDuplicateBooking = ({
	startDate,
	endDate,
	bookingReference,
	email,
	isWhiteLabel,
	shop,
}) => {
	return (
		<div className="technical-error">
			<div className="technical-error__intro">
				<FormattedMessage
					id="technical.error.duplicate.booking.label"
					values={{
						startDate: (
							<FormattedDate
								timeZone="UTC"
								value={new Date(startDate)}
								day="2-digit"
								month="2-digit"
								year="numeric"
							>
								{monthLabel => (
									<span className="technical-error__date">{monthLabel}</span>
								)}
							</FormattedDate>
						),
						endDate: (
							<FormattedDate
								timeZone="UTC"
								value={new Date(endDate)}
								day="2-digit"
								month="2-digit"
								year="numeric"
							>
								{monthLabel => (
									<span className="technical-error__date">{monthLabel}</span>
								)}
							</FormattedDate>
						),
						bookingReference: (
							<span className="technical-error__reference-number">
								{bookingReference}
							</span>
						),
						email: <span className="technical-error__email">{email}</span>,
					}}
				/>
			</div>

			<DontLeave message={<FormattedMessage id="confirmation.contact.continue.headline" />}>
				{isWhiteLabel ? (
					<ButtonLink
						variant="primary"
						size="lg"
						to={{ pathname: "/account/mybookings" }}
						data-testid={"go-to-my-bookings-button"}
					>
						<FormattedMessage id="technical.error.duplicate.booking.cta.label" />
					</ButtonLink>
				) : (
					<ButtonLink
						variant="primary"
						size="lg"
						to={{ pathname: `https://www.perfectstay.com/${shop}` }}
						target="_blank"
						rel="noopener noreferrer"
						data-testid={"go-to-my-bookings-button"}
					>
						<FormattedMessage id="technical.error.duplicate.booking.cta.label" />
					</ButtonLink>
				)}
			</DontLeave>
		</div>
	);
};

TechnicalErrorDuplicateBooking.propTypes = {
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	bookingReference: PropTypes.string,
	email: PropTypes.string,
	shop: PropTypes.string,
	isWhiteLabel: PropTypes.bool,
};

export default TechnicalErrorDuplicateBooking;
